import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { PhoneNumberService } from '@luggagehero/services';

@Directive({
  selector: '[lhPhoneNumber]',
  providers: [{ provide: NG_VALIDATORS, useExisting: PhoneNumberDirective, multi: true }],
})
export class PhoneNumberDirective implements Validator {
  @Input() lhPhoneNumber: 'single' | 'multiple' = 'single';

  constructor(private phoneNumberService: PhoneNumberService) {}

  validate(control: AbstractControl): { [key: string]: unknown } | null {
    if (this.lhPhoneNumber === 'multiple') {
      return this.phoneNumberService.validateMultiple(control);
    }
    return this.phoneNumberService.validateSingle(control);
  }
}
